import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { GRADING_MODAL } = ANALYTICS_CATEGORIES;

const { CLICK } = SNOWPLOW_EVENTS;

interface TriggerGradingTierModalAccordionOpenedOrClosedEventParams {
	grade: string;
	isExpand: boolean;
}

export const triggerGradingModalAccordionOpenedOrClosedEvent = ({
	grade,
	isExpand,
}: TriggerGradingTierModalAccordionOpenedOrClosedEventParams): void => {
	const eventPayload = getSnowplowEventPayload({
		category: GRADING_MODAL,
		customData: { label: grade },
		name: `dlr_grading_modal_accordion_${isExpand ? 'opened' : 'closed'}`,
		schemaName: CLICK.SCHEMA,
		version: CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
